import {Action} from "@ngrx/store";
import { HttpErrorResponse } from "@angular/common/http";
import {PaginationModel} from "@shared/models/pagination.model";
import {PageBillingCounterpartyModel} from "@services/back-office/model/pageBillingCounterpartyModel";
import {BillingCounterpartyModel} from "@services/back-office/model/billingCounterpartyModel";
import {StringRequest} from "@services/accounting/model/stringRequest";

export enum CounterpartiesActionTypes {
    LoadCounterparties = '[Counterparties] Load Counterparties',
    LoadCounterpartiesSuccess = '[Counterparties] Load Counterparties Success',
    LoadCounterpartiesFailure = '[Counterparties] Load Counterparties Failure',
    AddCounterparties = '[Counterparties] Add Counterparties',
    AddCounterpartiesSuccess = '[Counterparties] Add Counterparties Success',
    AddCounterpartiesFailure = '[Counterparties] Add Counterparties Failure',
    EditCounterparties = '[Counterparties] Edit Counterparties',
    EditCounterpartiesSuccess = '[Counterparties] Edit Counterparties Success',
    EditCounterpartiesFailure = '[Counterparties] Edit Counterparties Failure',
    UpdateCounterparty = '[Counterparties] Update Counterparties',
    UpdateCounterpartySuccess = '[Counterparties] Update Counterparties Success',
    DeleteCounterparties = '[Counterparties] Delete Counterparties',
    DeleteCounterpartiesSuccess = '[Counterparties] Delete Counterparties Success',
    DeleteCounterpartiesFailure = '[Counterparties] Delete Counterparties Failure',
    ChangePage = '[Counterparties] Change Page',
    SetInitialPagination = '[Counterparties] Set Initial Pagination',
    SetFilter = '[Counterparties] Set Filter',
    ClearFilter = '[Counterparties] Clear Filter',
    SetInitialState = '[Counterparties] Set Initial State',
    AddEditCounterPartySuccess = '[Counterparties] Add Edit CounterParty Success',
}

export class LoadCounterparties implements Action {
    readonly type = CounterpartiesActionTypes.LoadCounterparties;

    constructor(public payload?: { dontShowLoading: boolean }) {
    }
}

export class LoadCounterpartiesSuccess implements Action {
    readonly type = CounterpartiesActionTypes.LoadCounterpartiesSuccess;

    constructor(public payload: PageBillingCounterpartyModel) {
    }
}

export class LoadCounterpartiesFailure implements Action {
    readonly type = CounterpartiesActionTypes.LoadCounterpartiesFailure;

    constructor(public payload: HttpErrorResponse) {
    }
}


/** Add Agreements */
export class AddCounterparties implements Action {
    readonly type = CounterpartiesActionTypes.AddCounterparties;

    constructor(public payload: BillingCounterpartyModel) {
    }
}

export class AddCounterpartiesSuccess implements Action {
    readonly type = CounterpartiesActionTypes.AddCounterpartiesSuccess;

    constructor(public payload: BillingCounterpartyModel) {
    }
}

export class AddCounterpartiesFailure implements Action {
    readonly type = CounterpartiesActionTypes.AddCounterpartiesFailure;

    constructor(public payload: HttpErrorResponse) {
    }
}

/** Edit Counterparties */
export class EditCounterparties implements Action {
    readonly type = CounterpartiesActionTypes.EditCounterparties;

    constructor(public payload: BillingCounterpartyModel) {
    }
}

export class EditCounterpartiesSuccess implements Action {
    readonly type = CounterpartiesActionTypes.EditCounterpartiesSuccess;

    constructor(public payload: BillingCounterpartyModel) {
    }
}

export class EditCounterpartiesFailure implements Action {
    readonly type = CounterpartiesActionTypes.EditCounterpartiesFailure;

    constructor(public payload: HttpErrorResponse) {
    }
}

export class UpdateCounterparty implements Action {
    readonly type = CounterpartiesActionTypes.UpdateCounterparty;

    constructor(public payload: string) {
    }
}

export class UpdateCounterpartySuccess implements Action {
    readonly type = CounterpartiesActionTypes.UpdateCounterpartySuccess;

    constructor(public payload: BillingCounterpartyModel) {
    }
}

/** Delete Counterparties */
export class DeleteCounterparties implements Action {
    readonly type = CounterpartiesActionTypes.DeleteCounterparties;

    constructor(public payload: string) {
    }
}

export class DeleteCounterpartiesSuccess implements Action {
    readonly type = CounterpartiesActionTypes.DeleteCounterpartiesSuccess;

    constructor(public payload: string) {
    }
}

export class DeleteCounterpartiesFailure implements Action {
    readonly type = CounterpartiesActionTypes.DeleteCounterpartiesFailure;

    constructor(public payload: HttpErrorResponse) {
    }
}

/** Change Page */
export class ChangePage implements Action {
    readonly type = CounterpartiesActionTypes.ChangePage;
    constructor(public payload: PaginationModel) { }
}

/** Set Initial Pagination */
export class SetInitialPagination implements Action {
    readonly type = CounterpartiesActionTypes.SetInitialPagination;
}

/** Set Filter */
export class SetFilter implements Action {
    readonly type = CounterpartiesActionTypes.SetFilter;

    constructor(public payload: StringRequest) {
    }
}

/** Clear Filter */
export class ClearFilter implements Action {
    readonly type = CounterpartiesActionTypes.ClearFilter;
}

/** Set Initial State */
export class SetInitialState implements Action {
    readonly type = CounterpartiesActionTypes.SetInitialState;
}

export class AddEditCounterPartySuccess implements Action {
    readonly type = CounterpartiesActionTypes.AddEditCounterPartySuccess;

    constructor(public payload: BillingCounterpartyModel) {
    }
}

export type CounterpartiesActions =
    | LoadCounterparties
    | LoadCounterpartiesSuccess
    | LoadCounterpartiesFailure
    | AddCounterparties
    | AddCounterpartiesSuccess
    | AddCounterpartiesFailure
    | EditCounterparties
    | EditCounterpartiesSuccess
    | EditCounterpartiesFailure
    | UpdateCounterparty
    | UpdateCounterpartySuccess
    | DeleteCounterparties
    | DeleteCounterpartiesSuccess
    | DeleteCounterpartiesFailure
    | ChangePage
    | SetInitialPagination
    | SetFilter
    | ClearFilter
    | SetInitialState
    | AddEditCounterPartySuccess
    ;
